import React, { useEffect, useState, useRef } from 'react';
import '../styles/excel-reports.css';

interface Report {
  title: string;
  description: string;
  embedUrl: string;
}

const reports: Report[] = [
  {
    title: '2026Q3 CJV Forecast Summaries',
    description: '2026Q3 CJV Forecast Summaries.xlsx',
    embedUrl:
      'https://onxpresstp.sharepoint.com/sites/CJV/cc/_layouts/15/Doc.aspx?sourcedoc={55ca2ac2-25d6-4b09-8b2e-17df926baadd}&action=embedview&wdAllowInteractivity=False&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True&wdInConfigurator=True',
  },
];

const ExcelReports: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const initialLoadTimeRef = useRef<NodeJS.Timeout | null>(null);

  const getEmbedUrl = () => {
    const timestamp = Date.now();
    return `${reports[0].embedUrl}&wdForceAuthentication=True&t=${timestamp}`;
  };

  useEffect(() => {
    initialLoadTimeRef.current = setTimeout(() => {
      setIsLoading(false);
    }, 8000);

    return () => {
      if (initialLoadTimeRef.current) {
        clearTimeout(initialLoadTimeRef.current);
      }
    };
  }, []);

  const refreshIframe = () => {
setIsLoading(true);

    if (iframeRef.current) {
      iframeRef.current.src = getEmbedUrl();
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  };

  return (
    <div className="reports-container-fullscreen">
      <div className="refresh-button-container">
        <button
          className="refresh-button"
          onClick={refreshIframe}
          disabled={isLoading}
          type="button"
        >
          <span className="refresh-icon">↻</span> Refresh Report
        </button>
      </div>

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <div className="loading-text">Loading Excel Report...</div>
          <div className="loading-subtext">
            Please wait while we initialize your session
          </div>
        </div>
      )}

      <iframe
        ref={iframeRef}
        className="excel-frame-fullscreen"
        src={getEmbedUrl()}
        title={reports[0].title}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads allow-storage-access-by-user-activation allow-modals allow-top-navigation allow-top-navigation-by-user-activation"
        allow="autoplay; camera; microphone; clipboard-read; clipboard-write; cross-origin-isolated"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default ExcelReports;
